import React, { FC, memo } from 'react';

import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import logo from 'assets/IllustrationIcons/logo.svg';

export interface HeaderProps {}

export const Header: FC<HeaderProps> = memo(() => {
  return (
    <Box className="mb-8 flex items-center gap-1">
      <img src={logo} alt="Logo" />
      <Typography variant="h1Roboto" className="font-semibold text-black">
        Hyperlink
      </Typography>
    </Box>
  );
});
